<deprecated-labeled-field [label]="'Assign'">
  <div
    #dropdown
    class="dropdown"
    [class.placeholder]="!_.selectedUserName"
    [attr.tabindex]="0"
    (click)="_.setMenuOpen(true); $event.stopPropagation()"
  >
    <span class="display">
      <span class="display-value">
        {{ _.selectedUserName || 'Select' }}
      </span>
    </span>
    <div class="chevron">
      <riv-icon [name]="'ChevronDown'" [size]="18"></riv-icon>
    </div>
  </div>
  <ng-container *ngIf="_.menuOpen">
    <deprecated-callout
      *deprecated-callout
      [anchor]="dropdown"
      [preferredPosition]="AnchoredPosition.BOTTOM_LEFT"
      (close)="_.setMenuOpen(false)"
    >
      <div class="rv-menu">
        <div class="rv-menu-scrollable">
          <option-select
            [filterable]="true"
            [options]="_.userOptions"
            [selectedOptionId]="_.selectedUserId"
            (selectedOptionIdChange)="_.setSelectedUserId($event)"
            [multiSelect]="false"
            [showAvatars]="true"
            [selectedEnabled]="false"
          ></option-select>
        </div>
      </div>
    </deprecated-callout>
  </ng-container>
</deprecated-labeled-field>
